/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { apiAddPayType, apiUpdatePayType } from '@/api/miniApp';
export default /*#__PURE__*/_defineComponent({
  __name: 'payMethod',
  props: {
    gid: {
      type: Number,
      required: true,
      default: 0
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const types = [{
      type: 1,
      title: '客服'
    }, {
      type: 2,
      title: '小程序'
    }];
    const form = ref({
      id: 0,
      name: '',
      type: 1,
      val: ''
    });
    watch(() => props.data, val => {
      if (val && val.id) {
        form.value = val;
      }
    }, {
      immediate: true
    });
    const emits = __emit;
    const handleSubmit = () => {
      const api = props.data.id ? apiUpdatePayType : apiAddPayType;
      api({
        game_id: props.gid,
        ...form.value
      }).then(res => {
        if (res.code === 0) {
          emits('success');
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#updateMethod"
      }, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("确认")]),
        _: 1
      })])), _createVNode(_component_el_form, {
        model: _unref(form)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "支付名称",
          prop: "name",
          rules: {
            required: true,
            message: '请输入支付名称',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).name = $event),
            class: "width300px",
            placeholder: "请输入支付名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付类型",
          prop: "type",
          rules: {
            required: true,
            message: '清选择支付类型',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(form).type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).type = $event),
            placeholder: "请选择支付类型"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(types, item => {
              return _createVNode(_component_el_option, {
                key: item.type,
                value: item.type,
                label: item.title
              }, null, 8, ["value", "label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付跳转",
          prop: "val",
          rules: {
            required: true,
            message: '请输入支付跳转地址',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).val,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).val = $event),
            class: "width300px",
            placeholder: "请输入支付跳转地址"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});